/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription, filter, map } from "rxjs";
import { EnvConfigService } from './env-config.service'
import { environment } from "../environments/environment";
import { DataService } from "./admin/data.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  private routerSubscription: Subscription;

  baseUrl = environment.BASEURL
  imgURl = environment.IMGURL
  private readonly fallbackFavicon: string = 'assets/images/favicon.png';

  constructor(
    public translate: TranslateService,
    private dataService : DataService,
    private readonly router: Router,
    private readonly envService: EnvConfigService
  ) {
    // Theme color
    this.dataService.updateColor()

    // Initial language setup
    // const language = sessionStorage.getItem('language') || LanguageSettings.defaultSelectedLang;
    // this.translate.addLangs(LanguageSettings.languages);
    // this.translate.use(language);
    // translate.setDefaultLang(language);

    // Subscribe to loading state changes to trigger re-translation only when language changes
    // this.interceptorService.loading$
    //   .pipe(distinctUntilChanged())  // Only emit when the value changes
    //   .subscribe((loading) => {
    //     if (loading !== this.previousCondition) {  // Only execute when the value changes
    //       console.log(loading, "language change app component");
    //       const currentLang = sessionStorage.getItem('language') || LanguageSettings.defaultSelectedLang;
    //       this.translate.use(currentLang);
    //       translate.setDefaultLang(language);
    //       this.previousCondition = loading;  // Update previous condition to the new state
    //     }
    //   });
  }


  ngOnInit(): void {
    const dynamicFavicon = this.envService.getEnvData();
    const dynamicFaviconLink = this.imgURl + dynamicFavicon?.app?.favicon || this.fallbackFavicon
    this.envService.setFavicon(dynamicFaviconLink);
  

    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {

          const urlList = this.router.url.split('/');
          const lastUrlSegment = urlList[urlList.length - 1];
          if (lastUrlSegment.startsWith('auth')) {
            this.router.navigate(['/admin/dashboard']);
            return '';
          }
          // if(lastUrlSegment == 'auth' || lastUrlSegment == 'login'){
          //   this.authService.setLoginInfo(null)
          // }
          return urlList[urlList.length - 1];
        })
      )
      .subscribe((title) => {
        console.log(title)
      })
  }
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
